import siteReducers from 'yoda-site-components/lib/reducers';
import BreadCrumbNavReducer from 'yoda-site-components/lib/reducers/BreadCrumbNavReducer';
import LoadingReducer from 'yoda-site-components/lib/reducers/LoadingReducer';
import AppliedAdjustmentsReducer from 'yoda-site-components/lib/reducers/AppliedAdjustmentsReducer';
import UpdatedAdjustmentReducer from 'yoda-site-components/lib/reducers/UpdatedAdjustmentReducer';
import MessagesReducer from 'yoda-site-components/lib/reducers/MessagesReducer';
import BagItemsReducer from 'yoda-site-components/lib/reducers/BagItemsReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';

const rootReducer = {
    ...siteReducers,
    /**
     * bread crumbs IRIS component
     * yoda-site-components/src/iris/wrappers/BreadCrumbsNav/BreadCrumbsNav.jsx
     */
    breadCrumbsData: BreadCrumbNavReducer,
    /**
     * full screen loading
     * yoda-microsite-coupon/src/containers/Pages/Coupon/Coupon.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-homepage/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/Bundle/BundleAddToCart/BundleAddToCart.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-pdp/src/components/ImageZoom/ImageZoom.jsx
     * yoda-microsite-listing/src/common/CustomAddToCart/CustomAddToCart.jsx
     */
    isLoading: LoadingReducer,
    /**
     * get applied coupon
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * yoda-microsite-marketing/src/containers/Pages/Marketing/Marketing.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    appliedAdjustments: AppliedAdjustmentsReducer,
    /**
     * get adjustment update status
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * Coupon page IRIS component "couponlist"
     * Coupon drawer
     */
    isAdjustmentsUpdated: UpdatedAdjustmentReducer,
    /**
     * messages on various pages
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    messages: MessagesReducer,
    /**
     * Coupon page IRIS component "couponlist"
     */
    bagItems: BagItemsReducer,
    webvitals: WebvitalsReducer,
};

export default rootReducer;
